import { FaqTemplateDataModel } from '@/types/home';
import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export default function FaqContent({
  faqList,
  faqInfo,
}: {
  faqList: FaqTemplateDataModel;
  faqInfo: { title?: string; desc?: string };
}) {
  const [selectIndex, setSelectIndex] = useState<number>(-1);

  const toggleFaq = (id: number) => {
    setSelectIndex(selectIndex === id ? -1 : id);
  };

  return (
    <div className="mt-[100px]">
      <div className="text-center">
        <h2 className="lg:text-4xl font-bold text-gray-900 mb-4 text-3xl">{faqInfo?.title}</h2>
        {faqInfo.desc && <p className="text-lg text-gray-600 max-w-2xl mx-auto">{faqInfo.desc}</p>}
      </div>

      <div className="space-y-0">
        {faqList?.content_list?.map((item) => (
          <div key={item.id} className="border-b border-gray-200 last:border-b-0">
            <button
              onClick={() => toggleFaq(item.id)}
              className="w-full py-6 px-0 text-left flex items-center justify-between duration-200"
            >
              <div
                className="text-lg font-medium text-gray-900 pr-4"
                dangerouslySetInnerHTML={{ __html: item.question }}
              />
              <ChevronDown
                className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                  selectIndex === item.id ? 'rotate-180' : ''
                }`}
              />
            </button>

            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                selectIndex === item.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              }`}
            >
              <div className="pb-6 px-0">
                <div className="text-gray-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: item.answer }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
